export default __webpack_public_path__ + "static/media/lv5.9c73af43.png";